import script from "./CompaniesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompaniesView.vue?vue&type=script&setup=true&lang=js"

import "./CompaniesView.vue?vue&type=style&index=0&id=aae12c0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aae12c0c"]])

export default __exports__